import { createSelector } from 'reselect';
import { entitySelector, entityErrorByKeyword, entityErrorByKeywords } from 'helpers/entitySelector';

const mainEntities = (state) => state.db.entities;
const mainResults = (state) => state.db.result;
const mainErrors = (state) => state.db.errors;

const getMainSelector = createSelector(
  [mainEntities, mainResults, mainErrors],
  (entities, results, errors)  => {
    const user = entitySelector(entities, results, 'user', 'user'),
          classifiersAccess = entitySelector(entities, results, 'classifiersAccess'),
          entityRecommenderAccess = entitySelector(entities, results, 'entityRecommenderAccess'),
          accessError = entityErrorByKeyword(errors, 'have access'),
          generalError = entityErrorByKeywords(errors, ['DB_FETCH_FAILURE', 'ConnectionError']);
    return {
      user,
      classifiersAccess,
      entityRecommenderAccess,
      accessError,
      generalError
    };
  }
);

export default getMainSelector;



// WEBPACK FOOTER //
// ./src/components/layouts/main.selector.jsx